export default __webpack_public_path__ + "static/media/cutout_blanco_transparente.fe51a471.png";